/**
 * Created by renlaydel on 02/11/2017.
 */
import * as APIUtil from '../../apiUtils';
import * as apiCommon from '../../apiCommon';

import * as DocType from '../../../constants/constant_doc_types';
import * as TransactionStatus from '../../../constants/constant_transaction_status';
import { setLineItemId } from '../../inventory/helper_inventory';

export const savePurchaseOrder = async (app, params) => {
  const { data, user = {} } = params;

  let purchaseOrder = {
    alternate_classifications:
      (data.alternate_classification_ids || []).map(
        alternate_classification_id => ({ alternate_classification_id }),
      ) || [],
    brands: (data.brand_ids || []).map(brand_id => ({ brand_id })) || [],
    classifications:
      (data.classification_ids || []).map(classification_id => ({
        classification_id,
      })) || [],
    currency_id: data.currency_id,
    dispatched_date: APIUtil.toUtcDate(data.dispatched_date),
    dispatched_method_id: data.dispatched_method_id,
    doc_type: DocType.PURCHASE_ORDER,
    exchange_rate: data.exchange_rate,
    expected_eta: APIUtil.toUtcDate(data.expected_eta),
    id: data.id,
    lines: data.lines,
    location_id: data.location_id,
    location_type_id: data.location_type_id,
    notes: data.notes,
    purchase_contact_email: APIUtil.toStringText(data.purchase_contact_email),
    purchase_contact_id: data.purchase_contact_id,
    purchase_contact_number: APIUtil.toStringText(data.purchase_contact_number),
    purchase_receipts: data.purchase_receipts,
    reference_number: data.reference_number,
    status: data.status,
    status_id: data.status_id,
    subsidiary_id: data.subsidiary_id,
    supplier_id: data.supplier_id,
    custom_fields: data.custom_fields,
  };

  purchaseOrder.lines = purchaseOrder.lines.map(line => {
    if (isNaN(line.remaining_quantity) || line.remaining_quantity === null) {
      line.remaining_quantity = line.quantity;
    }

    return {
      ...line,
      item_id: line.item_id.split(':')[0],
      currency_id: data.currency_id,
      location_id: data.location_id,
      subsidiary_id: data.subsidiary_id,
      supplier_id: data.supplier_id,
    };
  });

  const savedPurchaseOrder = await apiCommon.saveDoc(app, {
    source: data,
    doc: purchaseOrder,
    user,
  });
  setLineItemId(savedPurchaseOrder);
  return savedPurchaseOrder;
};

export const fetchPurchaseOrderById = async (app, params) => {
  const { id } = params;
  const result = await apiCommon.getDoc(
    app,
    { id, docType: DocType.PURCHASE_ORDER },
    { assemble_custom_fields: true }
  );
  setLineItemId(result);
  return result;
};

export const getExistingPurchaseOrder = async (app, params) => {
  const { itemId, locationId, itemIds, purchaseOrderId } = params;
  const service = apiCommon.getAccountService(app, DocType.PURCHASE_ORDER);

  let query = {
    check_item_in_lines: true,
    excluded_status_cids: [
      TransactionStatus.CLOSED,
      TransactionStatus.CLOSED_ABANDONED,
    ],
    item_id: itemId,
    location_id: locationId,
  };

  if (itemIds) {
    query.item_ids = itemIds;
  }

  if (purchaseOrderId) {
    query.ne_purchase_order_id = purchaseOrderId;
  }

  const { data } = await service.find({ query });

  return data;
};

export const getPurchaseOrderReorder = async (app, location, supplier, limit) => {
  const api = apiCommon.getAccountService(app, 'purchase_order');
  const reorders = await api.get('reorder', { location, supplier, limit });
  return reorders;
}
